/* eslint-disable no-unused-vars */
import React, { useState } from 'react';

// Material components
import {
  Grid2,
  Typography,
  Breadcrumbs,
  Link as LinkMaterial,
  Box,
  SpeedDialAction,
  SpeedDial,
} from '@mui/material';

import { NavLink, useLocation, useNavigate, useParams } from 'react-router-dom';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

// Custom components
import { ChargeGrid } from './components';

import { useSelector, useDispatch } from 'react-redux';

// Component styles
import styles from './styles';
import { makeStyles } from '@mui/styles';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { countStatus } from 'js/actions/groupActions';
import theme from 'theme';
import { isAllowed } from 'helpers';
import { Add } from '@mui/icons-material';
import { history } from 'helpers/history';
const useStyles = makeStyles(styles);

export default function Charge(props) {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { charges } = useSelector((state) => state.charges.charges);
  const location = useLocation();
  const { groupId } = useParams();
  const navigate = useNavigate();
  const group = location && location.state ? location.state.group : null;
  const meter = location && location.state ? location.state.meter : null;
  const groupType = group ? group.energy_type.id_energy : null;
  const user = useSelector((state) => state.user.user);

  const [activeCharges, setActiveCharges] = useState(0);
  const [totalCharges, setTotalCharges] = useState(0);
  const [inactiveCharges, setInactiveCharges] = useState(0);

  const countStatusFuncResp = (data) => {
    setActiveCharges(data.charges_actives);
    setTotalCharges(data.totals);
    setInactiveCharges(parseInt(data.totals) - parseInt(data.charges_actives));
  };

  const handleCountStatusChanged = () => {
    dispatch(countStatus(groupId, countStatusFuncResp));
  };

  return (
    <DashboardLayout
      chargeName={group ? group.name : null}
      title={'Mediciones'}
    >
      <div className={classes.root}>
        <Grid2
          alignItems="center"
          container={true}
          sx={{ verticalAlign: 'middle' }}
        >
          <Grid2 size={{ lg: 8, md: 8, xs: 12 }}>
            <Typography
              sx={{ color: '#A53693', marginBottom: theme.spacing(2) }}
              variant="h2"
            >
              {intl.formatMessage({ id: 'app.charges.nav.chargeLab2' })}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              {isAllowed(user.permissions, ['corporative_read']) && meter && (
                <Breadcrumbs
                  arial-label="breadcrumb"
                  className={classes.breadcrumb}
                  separator=":"
                  sx={{ marginRight: theme.spacing(1) }}
                >
                  <LinkMaterial
                    color="inherit"
                    component={NavLink}
                    sx={{ color: '#A53693', textDecoration: 'none' }}
                    to={`/corporative/${meter.corporative_id}`}
                    state={meter}
                  >
                    {intl.formatMessage({ id: 'app.groups.nav.meters' })}
                  </LinkMaterial>
                  <LinkMaterial
                    color="inherit"
                    component={NavLink}
                    sx={{ textDecoration: 'none' }}
                    to={`/meter/${meter.id}`}
                    state={meter}
                  >
                    {meter
                      ? meter.name
                      : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
                  </LinkMaterial>
                  <Typography sx={{ fontWeight: 600, color: '#00AFEF' }}>
                    {' '}
                    |{' '}
                  </Typography>
                </Breadcrumbs>
              )}
              {meter && (
                <Breadcrumbs
                  arial-label="breadcrumb"
                  className={classes.breadcrumb}
                  separator=":"
                  sx={{ marginLeft: theme.spacing(1), color: '#A53693' }}
                >
                  <LinkMaterial
                    color="inherit"
                    component={NavLink}
                    to={`/meter/${meter.id}`}
                    state={meter}
                    sx={{ textDecoration: 'none' }}
                  >
                    {intl.formatMessage({ id: 'app.charges.nav.groupLab2' })}
                  </LinkMaterial>
                  <Typography variant="h5">
                    {group
                      ? group.name
                      : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
                  </Typography>
                </Breadcrumbs>
              )}
            </Box>
          </Grid2>

          <Grid2
            alignItems="bottom"
            size={{ lg: 4, md: 4, xs: 12 }}
            sx={{
              textAlign: 'right',
              verticalAlign: 'middle',
              display: 'flex-end',
            }}
          >
            <div
              style={{
                textAlign: 'right',
                paddingTop: '5px',
                alignItems: 'center',
                verticalAlign: 'bottom',
                display: 'flex',
                justifyContent: 'right',
                marginRight: '4px',
              }}
            >
              <div
                style={{
                  marginRight: '5px',
                  fontSize: '14px',
                  fontFamily: 'Arial',
                  fontWeight: '600',
                  float: 'left',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    color: '#fff',
                    textShadow: '0 0 2px black',
                    verticalAlign: 'middle',
                    textAlign: 'center',
                    width: '40px',
                    height: '40px',
                    marginRight: '1px',
                    marginLeft: '1px',
                    fontFamily: 'Arial',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    fontSize: '12px',
                    paddingTop: '12px',
                    fontWeight: '800',
                    backgroundImage: "url('/images/charge_turn_on_count.png')",
                  }}
                >
                  {activeCharges}{' '}
                </div>
                <div>On</div>
              </div>

              <div
                style={{
                  fontSize: '14px',
                  fontFamily: 'Arial',
                  fontWeight: '600',
                  float: 'left',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    color: '#fff',
                    textShadow: '0 0 2px black',
                    verticalAlign: 'middle',
                    textAlign: 'center',
                    width: '40px',
                    height: '40px',
                    marginRight: '1px',
                    marginLeft: '1px',
                    fontFamily: 'Arial',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    fontSize: '12px',
                    paddingTop: '12px',
                    fontWeight: '800',
                    backgroundImage: "url('/images/charge_turn_off_count.png')",
                  }}
                >
                  {inactiveCharges}
                </div>
                <div>Off</div>
              </div>
            </div>
          </Grid2>
        </Grid2>

        <div className={classes.content}>
          <ChargeGrid
            groupId={groupId}
            handleCountStatusChanged={() => {
              handleCountStatusChanged();
            }}
            typeEnergy={groupType}
          />
        </div>
        <SpeedDial
          sx={{
            position: 'fixed',
            bottom: 32,
            right: 32,
            '& .MuiFab-primary': {
              backgroundColor: '#00AFEF',
              color: '#fff',
              width: '60px',
              height: '60px',
              fontSize: '1.5em',
              '&:hover': {
                backgroundColor: 'rgb(0, 146, 199)',
              },
            },
          }}
          ariaLabel="SpeedDial basic example"
          icon={<Add />}
          onClick={() => navigate(`/newCharge/${meter.id}/${groupId}`)}
        />
      </div>
    </DashboardLayout>
  );
}
